import { saveAs } from "file-saver";

export const onDataLinkClick = (dataFile, filename) => {
  saveAs(dataFile, filename);
};
